import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { defaultDropList } from "components/WebDesigner/Data/WBComponentDefaults";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
 
export default class TestComponent extends WBComponent{

    constructor(){
        super();
        this.typename = wBComponentTypeNames.testComponent;
        this.dropList = defaultDropList;
        this.displayName = "Test Component";
        this.editList = CreateAttributeList();

    }
    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps): JSX.Element {

       
      
        return  <div {...GetNodeDomAttributes("",component,screenSize,isEditor)}>
        {/* <TestRender /> */}
        
      <CustomMultiSelect options={[
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        { label: "test", value: "test" },
        
        ]} startOpen={false} footer={undefined} placeholder={""} />
        </div>
    }

}